import { ExternalLink } from "lucide-react";

interface SkillstemAttributionProps {
  className?: string;
  variant?: "inline" | "block";
}

export const SkillstemAttribution = ({ className = "", variant = "inline" }: SkillstemAttributionProps) => {
  if (variant === "block") {
    return (
      <div className={`text-center ${className}`}>
        <p className="text-xs text-muted-foreground">
          An initiative of{" "}
          <a
            href="https://skillstem.in"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-1"
          >
            SkillSTEM Academy LLP
            <ExternalLink className="h-2.5 w-2.5" />
          </a>
        </p>
      </div>
    );
  }

  return (
    <span className={`text-xs text-muted-foreground ${className}`}>
      An initiative of{" "}
      <a
        href="https://skillstem.in"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium hover:text-primary transition-colors"
      >
        SkillSTEM Academy LLP
      </a>
    </span>
  );
};
